import { normalizeLegacyOperatorPayload } from "../payload/normalizeLegacyOperatorPayload";
import type { BuxusOperatorPayload, OperatorRecord } from "../payload/types";

/**
 * Turn downloaded JSON (main or stakeholder blob) into {@link BuxusOperatorPayload}.
 */
export function normalizeDownloadedOperatorJson(json: unknown): BuxusOperatorPayload {
  if (!json || typeof json !== "object") {
    throw new Error("Operator JSON must be an object");
  }
  const o = json as Record<string, unknown>;
  if ("operator" in o && o.operator && typeof o.operator === "object") {
    return normalizeLegacyOperatorPayload(json as BuxusOperatorPayload);
  }
  return { operator: json as OperatorRecord };
}
